<template>
  <!-- <ServerPicker /> -->
  <RatingPicker :become-a-legend="true" :defaul-value="1800" />
  <ExtraOptionPicker :disabled-options="disabledIds" />
</template>

<script setup>
import ServerPicker from "./pickers/ServerPicker.vue";
import RatingPicker from "./pickers/RatingPicker.vue";
import ExtraOptionPicker from "./pickers/ExtraOptionPicker.vue";
import { computed, watch, onMounted } from "vue";

const checkoutStore = useCheckoutStore();
const { getGamePack, getGame } = useGameStore();

const disabledIds = computed(() => {
  if (checkoutStore.getDetails?.desiredRating > 1800) {
    let options = [];
    const remoteControlOption = getGamePack?.pack_options?.find(
      (option) => option.const_title === "remote_control"
    );
    if (remoteControlOption) {
      options.push(remoteControlOption.id);
    }
    return options;
  }

  return [];
});

const clickSingleOption = (option) => {
  checkoutStore.removePackOption({
    optionIds: option?.rules?.disable || [],
  });
  checkoutStore.setPackOptions({
    options: [...checkoutStore.getPackOptions, option.id],
  });
};

const selectSelfPlay = () => {
  const selfPlayOption = getGamePack?.pack_options?.find(
    (option) => option.const_title === "remote_control"
  );
  if (selfPlayOption) {
    clickSingleOption(selfPlayOption);
  }
};

const selectPiloted = () => {
  const pilotedOption = getGamePack?.pack_options?.find(
    (option) => (option.const_title = "piloted")
  );
  if (pilotedOption) {
    clickSingleOption(pilotedOption);
  }
};

watch(
  () => checkoutStore.getDetails,
  (newVal) => {
    if (newVal.desiredRating > 1800) {
      selectPiloted();
    }
  },
  { deep: true }
);

const handleDetails = () => {
  checkoutStore.clearCheckout();
  checkoutStore.setServer(1);
  checkoutStore.setPlatform({
    platform: 1,
  });
  checkoutStore.setDetails({
    currentRating: 0,
    desiredRating: 1800,
  });
  checkoutStore.setGameAndPack({
    game: getGame.id,
    pack: getGamePack.id,
    fullGame: getGame,
    fullPack: getGamePack,
  });
};

handleDetails();

onMounted(() => {
  checkoutStore.setCalculating();
});
</script>
